import React, { useState } from "react";
import { CustomToolbar, CustomToolbarSelect} from "./components";
import {NoRecord,SearchingRecord } from "../../components";
import {

  Checkbox,
  FormControlLabel
} from "@material-ui/core";

import { TableRow, TableCell } from "@material-ui/core"
import Alert from '@material-ui/lab/Alert';
import useStyles from "./styles";



export const options = (meta, page, changePageOrSort, loading, handleSelectChange, selectedRecordIndex, selectAll, handleSelectAllChange, selectedRecord, selectedRecordLength, setSelectedRecords, setSelectedRecordIndexes, setselectedRecordLength, filterQuery, setSelectAll,emailModal,ACLAccess,sortBy,sortOrder,rowsPerPage,lastListViewSort,module) => ({

  filter: false,
  download: false,
  responsive: "vertical",
  serverSide: true,
  count: meta["total-records"],
  rowsPerPage: rowsPerPage,
  page,
  fixedHeader: true,
  fixedSelectColumn: true,
  search: false,
  print: false,
  viewColumns: false,
  selectableRows: meta["total-records"] ? true : false,
  pagination: meta["total-records"] > 0 ? true : false,
  sortOrder:lastListViewSort,//{'name':sortBy,'direction':sortOrder},
  // selectableRowsHeader: false,
  // selectableRowsHideCheckboxes: "multiple",
  // resizableColumns: true,
  // expandableRows: true,
  // rowsSelected: this.state.records.filter(p => this.state.selectedIds.includes(p.id)).map((p, i) => i),
  // onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => {
  //   console.log("Selected------->")
  //   console.log(currentRowsSelected)
  //   console.log(allRowsSelected)
  //   console.log(rowsSelected)

  // },
  onRowSelectionChange: (currentRowsSelected, allRowsSelected, rowsSelected) => handleSelectChange(currentRowsSelected, allRowsSelected, rowsSelected),
  rowsSelected: (selectedRecordIndex),
  // onTableChange: (action, tableState) => handlePageChange(),
  // onChangePage: (currentPage) => handlePageChange(),
  // renderExpandableRow: (rowData, rowMeta) => {
  //   console.log(rowData, rowMeta);
  //   return (
  //     <TableRow>
  //       <TableCell colSpan={rowData.length}>
  //         Custom expandable row option. Data: {JSON.stringify(rowData)}
  //       </TableCell>
  //     </TableRow>
  //   );
  // },
  // isRowExpandable: (dataIndex, expandedRows) => {
  //   if (dataIndex === 3 || dataIndex === 4) return false;

  //   // Prevent expand/collapse of any row if there are 4 rows expanded already (but allow those already expanded to be collapsed)
  //   if (expandedRows.data.length > 4 && expandedRows.data.filter(d => d.dataIndex === dataIndex).length === 0) return false;
  //   return true;
  // },
  // rowsExpanded: [0, 1],
  // renderExpandableRow: (rowData, rowMeta) => {
  //   const colSpan = rowData.length + 1;
  //   return (
  //     <TableRow>
  //       <TableCell colSpan={colSpan}>
  //         {JSON.stringify(rowData)}
  //       </TableCell>
  //     </TableRow>
  //   );
  // },

  // onRowClick: (rowData: string[], rowMeta: { dataIndex: number, rowIndex: number }) => {
  //   console.log("----RowClick");
  //   console.log("rowData: ", rowData);
  //   console.log("rowMeta: ", rowMeta);
  // },

  // onRowsSelect: (curRowSelected, allRowsSelected) => {
  //   // console.log("---RowSelect")
  //   // console.log("Row Selected: ", curRowSelected);
  //   // console.log("All Selected: ", allRowsSelected);
  //   // setSelectedRecords(allRowsSelected)
  // },
  // isRowSelectable: (dataIndex, selectedRows) => {
  //   //prevents selection of any additional row after the third
  //   if (selectAll) return true;
  //   //prevents selection of row with title "Attorney"
  //   // return data[dataIndex][1] != "Attorney";
  // },
  isRowSelectable: (dataIndex, selectedRows) => {
    //prevents selection of any additional row after the third
    if (selectAll) { return false } else { return true; };
    // if (selectedRows.data.length > 2 && selectedRows.data.filter(d => d.dataIndex === dataIndex).length === 0) return false;
    //prevents selection of row with title "Attorney"
    // return data[dataIndex][1] != "Attorney";
  },
  selectableRowsHeader: selectAll ? false : true,
  //tableBodyHeight: "100vh",
  // expandableRows:  true,
  rowsPerPageOptions: [rowsPerPage],
  customToolbar: () => {
    return <CustomToolbar selectAll={selectAll} handleSelectAllChange={handleSelectAllChange} selectedRecordLength={selectedRecordLength} emailModal={emailModal} />;
  },
  customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
    return <CustomToolbarSelect selectAll={selectAll} handleSelectAllChange={handleSelectAllChange} selectedRecord={selectedRecord} selectedRecordLength={selectedRecordLength} selectedRows={selectedRows} displayData={displayData} setSelectedRows={setSelectedRows} setSelectedRecords={setSelectedRecords} setSelectedRecordIndexes={setSelectedRecordIndexes} setselectedRecordLength={setselectedRecordLength} filterQuery={filterQuery} setSelectAll={setSelectAll} ACLAccess={ACLAccess} />;
  },
  onColumnSortChange: (action, tableState) => {
    // console.log("onColumnSortChange action",action);
    // console.log("tableState",tableState);
  },
  onTableChange: (action, tableState) => {
    // console.log("onTableChange tableState",action,tableState);
    switch (action) {
      case "changePage":
        if (tableState.sortOrder.hasOwnProperty("name")) {
          let directionToSort =
            tableState.sortOrder.direction === "desc"
              ? `-${tableState.sortOrder.name}`
              : tableState.sortOrder.name;
          changePageOrSort(tableState.page, directionToSort);

          break;
        } else {
          changePageOrSort(tableState.page);
        }
        // handlePageChange(tableState)
        break;
      case "sort":
         
        if (tableState.sortOrder.direction === "desc") {
          changePageOrSort(
            tableState.page,
            `-${tableState.sortOrder.name}`,
          );
          break;
        }
        changePageOrSort(tableState.page, tableState.sortOrder.name);

        break;
      default:
        //console.log(action + "action not handled.");
        break;
    }
  },
  textLabels: {
    body: { 
      noMatch: loading ? 
        <SearchingRecord />
        : 
       <NoRecord />
    },
    selectedRows: {
      text: selectAll ?
        <FormControlLabel
          control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} name="selectAllOption" />}
          label="Deselect All "
        /> : null,
      delete: "Delete",
      deleteAria: "Delete Selected Rows",
    }
  }
});
